import ServiceError from "./ServiceError"

async function execMailNotificationRequest(method) {
  let response = null
  try {
    response = await fetch(
      `${process.env.PERSONALISATION_HOST}/api/content/category/mailNotification`,
      {
        method,
        mode: "cors",
        credentials: "include",
      }
    )
  } catch (err) {
    console.error(`Unable to ${method} mail notificaton status`, err)
    throw new ServiceError(ServiceError.STATUS_CONNECTION_ERROR, err.message)
  }
  if (!response.ok) {
    throw new ServiceError(
      response.status,
      `Got no success status. Got status ${response.status}.`
    )
  }

  const data = await response.json()
  if (data.result == null) {
    console.error("Unexpected user mail notification status response", data)
    throw new ServiceError(
      ServiceError.STATUS_INVALID_DATA,
      `Invalid response data.`
    )
  }
  return data.result
}

export async function isMailNotificationActivated() {
  return execMailNotificationRequest("GET");
}

export async function activateMailNotifications() {
  return execMailNotificationRequest("PUT");
}

export async function deactivateMailNotifications() {
  return execMailNotificationRequest("DELETE");
}
